import React from "react";
import { Link } from "react-router-dom";
import { homepageURL } from "../../constants/path_constants";
import styles from "./NotFoundPage.module.css";

const ILLUSTRATION =
  "https://cdn.venuemonk.com/images/vm-404.png";

const NotFoundPage = () => {
  return (
    <div className={styles.wrap} role="main">
      <h1 className={styles.heading}>
        <span className={styles.headingAccent}>404</span> ERROR!
      </h1>
      <p className={styles.sub}>
        The link you followed is probably broken or the page has been removed.
      </p>
      <Link to={homepageURL} className={styles.homeLink}>
        Return to Home Page
      </Link>
      <div className={styles.illustrationWrap}>
        <img
          src={ILLUSTRATION}
          alt="Page not found illustration"
          className={styles.illustration}
          decoding="async"
        />
      </div>
    </div>
  );
};

export default NotFoundPage;
